import qs from 'qs';
import { AxiosInstance } from 'axios';
import { CollectionResource } from '@app/data/resources';
import {
    CreateTaskDeliverableCommentInput,
    TaskDeliverableCommentFilterInput,
    UpdateTaskDeliverableCommentInput,
} from './inputs';
import { TaskDeliverableCommentResource } from './resources';
import { TaskDeliverableCommentRef } from './refs';

export default class TaskDeliverableComment {
    private basePath = '/api/task-deliverable-comment';
    private http: AxiosInstance;

    constructor(http: AxiosInstance) {
        this.http = http;
    }

    // Get list of task deliverable comment
    get = async (
        filter: TaskDeliverableCommentFilterInput
    ): Promise<CollectionResource<TaskDeliverableCommentResource, {}>> => {
        const query = qs.stringify({ ...filter });

        const { data } = await this.http.get(`${this.basePath}/?${query}`);
        return data;
    };

    // Create new task deliverable comment
    create = async (input: CreateTaskDeliverableCommentInput): Promise<TaskDeliverableCommentRef> => {
        const { data } = await this.http.post(`${this.basePath}/`, input);
        return data;
    };

    // Update task deliverable comment
    update = async (id: ID, input: UpdateTaskDeliverableCommentInput): Promise<TaskDeliverableCommentRef> => {
        const { data } = await this.http.put(`${this.basePath}/${id}`, input);
        return data;
    };

    // Archive task deliverable comment
    archive = async (id: ID): Promise<TaskDeliverableCommentRef> => {
        const { data } = await this.http.delete(`${this.basePath}/${id}`);
        return data;
    };

    // Restore archived task deliverable comment
    restore = async (id: ID): Promise<TaskDeliverableCommentRef> => {
        const { data } = await this.http.post(`${this.basePath}/${id}/restore`);
        return data;
    };

    // Mark comment as resolved
    markAsResolved = async (id: ID): Promise<TaskDeliverableCommentRef> => {
        const { data } = await this.http.put(`${this.basePath}/${id}/resolve`);
        return data;
    };

    // Mark comment as resolved
    removeResolvedStatus = async (id: ID): Promise<TaskDeliverableCommentRef> => {
        const { data } = await this.http.delete(`${this.basePath}/${id}/resolve`);
        return data;
    };
}
